/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiJMESPathExpressionTestResult
 */
export interface InternalApiJMESPathExpressionTestResult {
    /**
     * 
     * @type {string}
     * @memberof InternalApiJMESPathExpressionTestResult
     */
    expressionResult: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiJMESPathExpressionTestResult
     */
    entity: string;
}

/**
 * Check if a given object implements the InternalApiJMESPathExpressionTestResult interface.
 */
export function instanceOfInternalApiJMESPathExpressionTestResult(value: object): value is InternalApiJMESPathExpressionTestResult {
    if (!('expressionResult' in value) || value['expressionResult'] === undefined) return false;
    if (!('entity' in value) || value['entity'] === undefined) return false;
    return true;
}

export function InternalApiJMESPathExpressionTestResultFromJSON(json: any): InternalApiJMESPathExpressionTestResult {
    return InternalApiJMESPathExpressionTestResultFromJSONTyped(json, false);
}

export function InternalApiJMESPathExpressionTestResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiJMESPathExpressionTestResult {
    if (json == null) {
        return json;
    }
    return {
        
        'expressionResult': json['expressionResult'],
        'entity': json['entity'],
    };
}

export function InternalApiJMESPathExpressionTestResultToJSON(json: any): InternalApiJMESPathExpressionTestResult {
    return InternalApiJMESPathExpressionTestResultToJSONTyped(json, false);
}

export function InternalApiJMESPathExpressionTestResultToJSONTyped(value?: InternalApiJMESPathExpressionTestResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expressionResult': value['expressionResult'],
        'entity': value['entity'],
    };
}

